export default __webpack_public_path__ + "static/media/wifiOnboard.806fdf59.svg";